import { render, staticRenderFns } from "./ProfileGift.vue?vue&type=template&id=13262040&scoped=true&"
import script from "./ProfileGift.vue?vue&type=script&lang=js&"
export * from "./ProfileGift.vue?vue&type=script&lang=js&"
import style0 from "./ProfileGift.vue?vue&type=style&index=0&id=13262040&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13262040",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
